import { Link } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { track } from "@/lib/analytics"
import { RelationshipMap } from "./RelationshipMap"

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto grid max-w-6xl gap-12 px-4 py-20 sm:px-6 sm:py-28 lg:grid-cols-[1.15fr_1fr] lg:items-center lg:gap-8">
        <div>
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-accent-display">
            The FullCast Podcast Growth Partnership
          </span>
          <h1 className="display-1 mt-5">
            Build Authority Through Better Conversations
          </h1>
          <p className="mt-6 max-w-xl text-lg text-ink-body">
            We help established founders, coaches, consultants, advisors, and
            expert-led businesses turn weekly video podcast interviews into
            trust-rich content, stronger positioning, and strategic relationship
            opportunities.
          </p>
          <p className="mt-4 max-w-xl text-ink-muted">
            We help clarify your message, identify stronger guest opportunities,
            prepare better interviews, produce polished episodes, and repurpose
            every conversation into content that builds trust.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Button asChild size="lg">
              <Link href="/apply" onClick={() => track("CTA Click")}>
                Apply for a Podcast Growth Fit Call
              </Link>
            </Button>
            <Button asChild variant="secondary" size="lg">
              <a href="#offer">See how the partnership works</a>
            </Button>
          </div>

          <p className="mt-8 text-sm text-ink-muted">
            Founder-led podcast strategy and production from the team behind
            130+ launched shows.
          </p>
        </div>

        <div className="hidden lg:block">
          <RelationshipMap />
        </div>
      </div>
    </section>
  )
}
